import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";

// ... (imports remain unchanged)

function ResumenOmEvaluador({ id }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/TablaOPModel/" + id,
    })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setData]);

  console.log("data:", data); // Log the value of data to the console

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-body">
                <hr />
                {loading ? (
                  <p>Loading...</p>
                ) : (
                  <div className="table-responsive">
                    <table
                      className="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Total oportunidades</th>
                          <th>Total agrupapas</th>
                          <th>Total Solucionadas</th>
                          <th>Total Parciales</th>
                          <th>Total Reiteradas</th>
                          <th>Total Nuevas</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{data.totalOportunidades}</td>
                          <td>{data.totalAgrupapas}</td>
                          <td>{data.totalSolucionadas}</td>
                          <td>{data.totalParciales}</td>
                          <td>{data.totalReiteradas}</td>
                          <td>{data.totalNuevas}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ResumenOmEvaluador;
